export const Tables = {
  _token: localStorage.getItem("_token"),
  update(url, param, result, proxy) {
    return fetch(`${proxy}${url}/${param}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        Authorization: this._token,
      },
      body: JSON.stringify(result),
    });
  },
};
